import {Exclude, Expose, instanceToPlain, plainToInstance, Transform} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../web/validation";
import {Entity} from "./entity";
import {getDatabaseCodeTransformer} from "./transfomers/transformers";
import {FleetAssetCapabilityType, toFleetAssetCapabilityType} from "./fleet-asset-capability-type";

export const FleetAssetCapabilityCodec = t.intersection([
  t.type({
    id: t.string,
    fleetAssetId: t.string,
    fleetAssetType: t.string,
    fleetCapabilityType: t.string,
    createDttm: t.number,
    lastModifiedDttm: t.number,
  }),
  t.partial({
    createdById: t.string,
    lastModifiedById: t.string,
  }),
]);

export type FleetAssetCapability = t.TypeOf<typeof FleetAssetCapabilityCodec>;

@Exclude()
export class FleetAssetCapabilityEntity implements Entity {
  @Expose()
  id!: string;

  @Expose()
  fleetAssetId!: string;

  @Expose()
  fleetAssetType!: string;

  @Transform(getDatabaseCodeTransformer(toFleetAssetCapabilityType))
  @Expose()
  fleetCapabilityType!: FleetAssetCapabilityType;

  @Expose()
  createdById?: string;

  @Expose()
  lastModifiedById?: string;

  @Expose()
  createDttm!: number;

  @Expose()
  lastModifiedDttm!: number;

  readonly entityType = 'FLEETASSETCAPAB';

  get displayName(): Readonly<string> {
    return this.id;
  }

  /**
   * Constructor for FleetAssetCapabilityEntity. Recommend using the {@link create} method instead.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(value: FleetAssetCapability): FleetAssetCapabilityEntity {
    return plainToInstance(FleetAssetCapabilityEntity, value, {
      excludeExtraneousValues: true,
    });
  }

  loadTypeValue(): Promise<FleetAssetCapability> {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(FleetAssetCapabilityCodec, object);
  }

  asTypeValue(): FleetAssetCapability {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSONNow(FleetAssetCapabilityCodec, object);
  }
}

export interface FleetAssetCapabilityRequestDTO {
  capabilities: string[]
}

export interface FleetAssetCapabilityPatchRequestDTO {
  add: string[]
  remove: string[]
}
